<template>
    <v-container fill-height class="align-start">
        <loading-overlay loading></loading-overlay>
    </v-container>
</template>

<script>
export default {
    mounted() {
        const request = this.$store.state.unregisteredPaymentRequest;

        if (request) {
            const {
                id,
                benefactor_token: hash,
            } = request;

            const { query } = this.$route;
            this.$router.push({
                name: 'unregistered-payment-requests',
                params: {
                    id,
                    hash,
                },
                query,
            });
        } else {
            this.$swal({
                type: 'error',
                title: 'Something went wrong',
                text: 'Missing request',
            });
        }
    },
};
</script>
